<template>
  <div class="text-input-container mb-3">
    <label>
      <question-display :question="question"></question-display>
    </label>
    <input
      type="text"
      :value="inputValue"
      :placeholder="question.placeholder || 'Enter Value'"
      class="form-control"
      @input="updateInput"
    />


    <small v-if="showValidation && question.required && !inputValue" class="text-danger">This field is required.</small>
    <small v-else-if="showValidation && !isValidInput()" class="text-danger">{{ erroMsg }}</small>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
      QuestionDisplay
  },
  props: {
    question: Object,
    showValidation: Boolean // Add showValidation prop
  },
  data() {
    return {
      inputValue: surveyService.getAnswer(this.question.id) || '',
      erroMsg : ''
    };
  },
  computed: {
    storedAnswer() {
      return surveyService.getAnswer(this.question.id);
    }
  },
  methods: {
    updateInput(event) {
  const newValue = event.target.value;

  if (this.question.validators?.on_type_pattern) {
    try {
      const typePattern = new RegExp(this.question.validators.on_type_pattern);
      if (newValue !== '' && !typePattern.test(newValue)) {
        event.target.value = this.inputValue; // restore previous value
        return;
      }
    } catch (err) {
      console.error('Invalid on_type_pattern:', err);
    }
  }

  this.inputValue = newValue;
  surveyService.setAnswer(this.question.id, this.inputValue);
  this.$emit('input', this.inputValue);
}
,

    
    isValidInput() {
      let status = true;
      this.erroMsg = '';

      try {
        if (this.question.validators?.pattern && !new RegExp(this.question.validators.pattern).test(this.inputValue)) {
          status = false;
          this.erroMsg = this.question.validators['error-msg'] || 'Invalid input.';
        }
      } catch (err) {
        console.error('Invalid regex pattern:', err);
        status = false;
        this.erroMsg = 'Validation error.';
      }

      return status;
    }

  },
  watch: {
    question(newQuestion) {
      this.inputValue = surveyService.getAnswer(newQuestion.id) || '';
    },
    // Picks up answers set asynchronously after this field already mounted
    // (e.g. Q2a's airport-name autofill, which resolves in the background).
    // Only applies if the field is still empty, so it never overwrites user input.
    storedAnswer(newVal) {
      if (newVal && !this.inputValue) {
        this.inputValue = newVal;
      }
    }
  }
};
</script>
